import React from 'react';
import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../../Base.constants';
import { DATE_FORMATS, formatDate } from '../../../../utils/dateUtils';
import styles from './RecommendationDate.module.scss';

const cx = classNames.bind(styles);

export enum RecommendationType {
  REVIEW = 'Recommendation Reviewed' as any,
  CHANGE = 'Recommendation Changed' as any,
  COMMENT_CHANGE = 'Comment Changed' as any,
}

interface RecommendationDateProps {
  type: RecommendationType;
  date?: string;
  articleId?: number;
  print?: boolean;
}

const RecommendationDate = ({ type, date, articleId, print }: RecommendationDateProps): React.ReactElement => {
  const text = `${type}: ${formatDate(date, DATE_FORMATS.MONTH_ABBR_DATE)}`;
  const dataTestId = `${RecommendationType[type].toLowerCase()}-date`;
  return articleId ? (
    <div className={cx('body', { 'is-printed': print })}>
      <Link to={ROUTES.article(articleId)} data-testid={dataTestId}>
        {text}
      </Link>
    </div>
  ) : (
    <div className={cx('body', { 'is-printed': print })} data-testid={dataTestId}>
      {text}
    </div>
  );
};

export default RecommendationDate;
